import styled from 'styled-components'

export const LabeledSwitch = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  column-gap: 15px;

  @media (min-width: 1200px) {
    column-gap: 30px;
    width: 365px;
  }

  .MuiSwitch-root {
    margin-top: 0;
  }

  .MuiSwitch-thumb {
    background-image: unset;
  }

  & input[type='checkbox'] + span {
    padding-left: unset;
  }
`

export const Label = styled.label<{ $disabled: boolean }>`
  font-size: 16px;
  font-weight: bold;
  cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
`

export const Info = styled.span`
  grid-column: 1;
  font-size: 14px;
`

export const ReadMore = styled.button`
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  color: ${(props) => props.theme.palette.primary.main};
  text-decoration: underline;
  cursor: pointer;
`
